import { formContactSchema } from "@complex/Contact/Dropdown/resolver";
import { addressSchema } from "@root/utils/resolvers/address";
import { documentSchema } from "@root/utils/resolvers/document";
import { placeSchema } from "@root/utils/resolvers/place";
import { settingValueMasterSchema } from "@root/utils/resolvers/settingValue";
import { type InferType, array, boolean, date, mixed, object, string } from "yup";

const formDocumentSchema = object({
  file: mixed((input): input is File => input instanceof File)
    .default(undefined)
    .optional(),
  info: documentSchema.default(undefined).optional(),
});

export const formSchema = object({
  name: string().required("Ce champ est obligatoire"),
  permanent: string().oneOf(["permanent", "temporary"], "Ce champ est obligatoire"),
  serviceDates: object({
    startDate: date().defined().nullable().default(null),
    endDate: date().defined().nullable().default(null),
  })
    .nullable()
    .test("serviceDates-required-when-temporary", "Ce champ est obligatoire", (value, context) => {
      const permanent = context.parent.permanent;
      if (permanent === "temporary") {
        return !!(value?.startDate && value?.endDate);
      }
      return true;
    }),
  challenges: array(
    object({
      _id: string().required(),
      name: string().required(),
      tags: array(string().required()).required(),
    }).required()
  ).when("$isAuthorizedTags", {
    is: true,
    then: (schema) => schema.optional(),
    otherwise: (schema) => schema.min(1, "Ce champ est obligatoire").required(),
  }),
  tags: array(string().required()).when("$isAuthorizedTags", {
    is: true,
    then: (schema) => schema.min(1, "Ce champ est obligatoire").required("Ce champ est obligatoire"),
    otherwise: (schema) => schema.optional(),
  }),
  financingModes: array(settingValueMasterSchema).required().ensure().required("Ce champ est obligatoire"),
  favoriteChallenges: array(string().required("Ce champ est obligatoire")),
  description: string(),
  beneficiaries: string(),
  registrationModalities: string(),
  url: string().url("Format de l'URL incorrect"),
  isRemote: boolean().required(),
  address: addressSchema.nullable().when("isRemote", {
    is: false,
    then: (schema) => schema.required("Ce champ est obligatoire"),
  }),
  provider: object({
    name: string().required("Ce champ est obligatoire"),
    website: string().matches(
      /^$|((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
      "Ce champ est mal formaté."
    ),
    providerId: string().when("$isPartnerAuthorized", {
      is: true,
      then: (schema) =>
        schema.test("provider-name-or-id", "Ce champ est obligatoire", (value, context) =>
          Boolean(value || context.parent.name)
        ),
      otherwise: (schema) => schema.notRequired(),
    }),
  }).required(),
  createStructurePartner: boolean().default(true),
  contact: formContactSchema.nullable(),
  documents: array(formDocumentSchema.required()).ensure().max(5).required(),
  perimeter: array(placeSchema),
});

export type TModalSocialOfferFormResolver = InferType<typeof formSchema>;
